{
  "version": 1,
  "asset_id": "5ebba506-7eec-42a7-b0e3-7f8676e03658",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/5ebba506-7eec-42a7-b0e3-7f8676e03658/g20.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/5ebba506-7eec-42a7-b0e3-7f8676e03658/g20.jpg",
  "original_filename": "g20.jpg",
  "size": 2916352,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:52:58Z"
}
